import { createFileRoute, notFound } from '@tanstack/react-router';

import { routeMetadata } from '@/app/lib/tanstack-router';
import { Account } from '@/app/network/models/v1/account';
import { CurrentUserResponse } from '@/app/network/models/v1/user';
import { AccountDetailsPage } from '@/settings/pages/account-details';
import { userKeys } from '@/shared/user/queries';

export const Route = createFileRoute('/settings/_layout/accounts/$accountNumber')({
  loader: async ({ params, context }) => {
    const parsedAccountNumber = parseInt(params.accountNumber, 10);

    if (Number.isNaN(parsedAccountNumber)) {
      throw notFound();
    }

    const userData = context.queryClient.getQueryData(userKeys.authenticated()) as CurrentUserResponse;
    const account = userData?.accounts?.find(it => it.account_number === parsedAccountNumber);

    if (!account) {
      throw notFound();
    }

    return { account };
  },
  head: () => ({
    meta: routeMetadata('Account Details')
  }),
  component: AccountRoute,
  staticData: {
    headerSection: null
  }
});

function AccountRoute() {
  const { account } = Route.useLoaderData() as { account: Account };

  return <AccountDetailsPage account={account}/>;
}
